// Frontend mirror of the source-document role taxonomy (the authoritative copy is the CommonJS module
// lambda/solnstudio/solnstudio-api/lib/docRoles.js, which the React bundle can't import). Keep the keys
// in sync with the backend — the backend normalizes anything unknown to 'other', so a drift here is
// safe but means a role won't display its friendly label.

export const ROLE_OPTIONS = [
  { value: 'sow', label: 'Statement of Work / contract', blurb: 'Scope & deliverables (sales-prepared).' },
  { value: 'existing-env', label: 'Existing environment / current-state', blurb: 'Legacy menu trees, call-flow diagrams, IVR exports.' },
  { value: 'integration', label: 'Integration & API documentation', blurb: 'External systems to integrate with.' },
  { value: 'design-input', label: 'Workshop notes / design input', blurb: 'Filled workshop template, notes, use-case lists.' },
  { value: 'other', label: 'Other / reference', blurb: 'Supporting material.' },
];

export const DEFAULT_ROLE = 'other';

const LABELS = Object.fromEntries(ROLE_OPTIONS.map((o) => [o.value, o.label]));

export function roleLabel(role) {
  return LABELS[role] || LABELS[DEFAULT_ROLE];
}
